import React, { useContext } from "react";
import styles from "./Footer.module.scss";
import line from "./Line.png";
import { Context } from "../Store";
import UpboxLinks from "./UpboxLinks";
import callPhone from "../../imgs/callPhone.svg";
import linkedinLogo from "../../imgs/linkedin.png";
import youtubeLogo from "../../imgs/youtube.svg";
import twitterLogo from "../../imgs/twitter.svg";
import facebookLogo from "../../imgs/facebook.svg";
import instagramLogo from "../../imgs/instagram.svg";

import arrowUp from "./arrowUp.svg";
import arrowDown from "./arrowDown.svg";

const Footer = () => {
  let {
    dir,
    handelDirection,
    isHovering,
    setIsHovering,
    siteInfoRes,
    siteInfoLoading,
  } = useContext(Context);
  let {
    footer,
    facebook,
    instagram,
    snap,
    tiktok,
    twitter,
    youtube,
    phone,
    googlePlay,
  } = siteInfoRes;

  return (
    <footer id={styles.footer}>
      {!siteInfoLoading && (
        <div className={styles.container}>
          <h2 className={styles.copyRight}>{footer}</h2>
          <div className={styles.items}>
            <div className={styles.socialMedia}>
              <a href={instagram} target="_blank">
                <img src={instagramLogo} alt="" />
              </a>
              {/* <a href="https://bit.ly/3eCNZ42" target="_blank"> */}
              <a href={snap} target="_blank">
                <img src={linkedinLogo} alt="" />
              </a>
              {/* <a href="https://bit.ly/3ge6gVN" target="_blank"> */}
              <a href={youtube} target="_blank">
                <img src={youtubeLogo} alt="" />
              </a>
              {/* <a href="https://bit.ly/3eEMbaD" target="_blank"> */}
              <a href={twitter} target="_blank">
                <img src={twitterLogo} alt="" />
              </a>
              {/* <a
                href="https://www.facebook.com/people/My-Cash/100086904123748/"
                target="_blank"
              > */}
              <a href={facebook} target="_blank">
                <img src={facebookLogo} alt="" />
              </a>
            </div>
            <img src={line} alt="" />
            <div className={styles.call}>
              {dir === "ltr" ? (
                <>
                  <img style={{ marginRight: 8 }} src={callPhone} alt="" />
                  <span>{phone}</span>
                </>
              ) : (
                <>
                  <span style={{ marginLeft: 8 }}> {phone}</span>
                  <img src={callPhone} alt="" />
                </>
              )}
            </div>
            <img src={line} alt="" />
            <button onClick={handelDirection}>
              {dir === "ltr" ? "Ar" : "En"}
            </button>
            <img className={styles.lastLine} src={line} alt="" />
            <div
              onMouseLeave={() => setIsHovering(false)}
              className={styles.more}
            >
              <div
                onMouseLeave={() => setIsHovering(false)}
                className={
                  dir === "ltr" ? styles.hoverLayerLtr : styles.hoverLayerRtl
                }
              ></div>
              <button onMouseOver={() => setIsHovering(true)}>
                {dir === "ltr" ? "More" : "المزيد"}{" "}
                <img
                  src={isHovering ? arrowUp : arrowDown}
                  className={dir === "ltr" ? styles.iL : styles.iR}
                  alt=""
                />
              </button>
              <div
                onMouseOver={() => setIsHovering(true)}
                onMouseLeave={() => setIsHovering(false)}
                className={
                  isHovering
                    ? `${styles.showUpbox} ${styles.upbox}`
                    : `${styles.upbox}`
                }
                id={
                  dir === "ltr"
                    ? `${styles.showUpboxLtr}`
                    : `${styles.showUpboxRtl}`
                }
              >
                <ul
                  id={
                    dir === "ltr"
                      ? styles.borderRadiusLtr
                      : styles.borderRadiusRtl
                  }
                  className={styles.links}
                >
                  <UpboxLinks googlePlay={googlePlay} />
                </ul>
              </div>
            </div>
          </div>
        </div>
      )}
    </footer>
  );
};

export default Footer;
